import { EmojiEvents, Person, School } from "@mui/icons-material";
import React from "react";
import Style from "./offer.module.scss";

function Offer(props) {
  const { offer } = props;
  return (
    <section id="mc-section-1" className="mc-section-1 section">
      <div className="container">
        <div className="flex justify-center mb-4">
          <div className="col-md-8 col-offset-md-3">
            <div className="mc-section-1-content-1 text-center">
              <h2 className="big">{offer?.title}</h2>
              <p className="mc-text">{offer?.description}</p>
              {/* <a href="#" className="mc-btn btn-style-1">About us</a> */}
            </div>
          </div>
          </div>
          <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className="col-sm-12 col-md-4">
                <div className="featured-item">
                {offer?.content &&
                    <div className="flex align-center">
                      <img style={{width:30,height:30}} className="mr-4" src={JSON.parse(offer?.content)['icon_1']}></img>
                      <h4 className="title-box text-uppercase py-4">{JSON.parse(offer?.content)['title_1']}</h4>
                    </div>}
                  {offer?.content && <p>{JSON.parse(offer?.content)['description_1']}</p>}
                </div>
              </div>
              <div className="col-sm-12 col-md-4">
                <div className="featured-item">
                {offer?.content &&
                    <div className="flex align-center">
                      <img style={{width:30,height:30}} className="mr-4" src={JSON.parse(offer?.content)['image_2']}></img>
                      <h4 className="title-box text-uppercase py-4">{JSON.parse(offer?.content)['title_2']}</h4>
                    </div>}
                  {offer?.content && <p>{JSON.parse(offer?.content)['description_2']}</p>}
                </div>
              </div>
              <div className="col-sm-12 col-md-4">
                <div className="featured-item">
                {offer?.content &&
                    <div className="flex align-center">
                      <img style={{width:30,height:30}} className="mr-4" src={JSON.parse(offer?.content)['image_3']}></img>
                      <h4 className="title-box text-uppercase py-4">{JSON.parse(offer?.content)['title_3']}</h4>
                    </div>}
                  {offer?.content && <p>{JSON.parse(offer?.content)['description_3']}</p>}
                </div>
              </div>
              <div className="col-sm-12 col-md-4">
                <div className="featured-item">
                {offer?.content &&
                    <div className="flex align-center">
                      <img style={{width:30,height:30}} className="mr-4" src={JSON.parse(offer?.content)['image_4']}></img>
                      <h4 className="title-box text-uppercase py-4">{JSON.parse(offer?.content)['title_4']}</h4>
                    </div>}
                  {offer?.content && <p>{JSON.parse(offer?.content)['description_4']}</p>}
                </div>
              </div>
              <div className="col-sm-12 col-md-4">
                <div className="featured-item">
                {offer?.content &&
                    <div className="flex align-center">
                      <img style={{width:30,height:30}} className="mr-4" src={JSON.parse(offer?.content)['image_5']}></img>
                      <h4 className="title-box text-uppercase py-4">{JSON.parse(offer?.content)['title_5']}</h4>
                    </div>}
                  {offer?.content && <p>{JSON.parse(offer?.content)['description_4']}</p>}
                </div>
              </div>
              <div className="col-sm-12 col-md-4">
                <div className="featured-item">
                  {offer?.content &&
                    <div className="flex align-center">
                      <img style={{width:30,height:30}} className="mr-4" src={JSON.parse(offer?.content)['image_6']}></img>
                      <h4 className="title-box text-uppercase py-4">{JSON.parse(offer?.content)['title_6']}</h4>
                    </div>}
                  {offer?.content && <p>{JSON.parse(offer?.content)['description_6']}</p>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Offer;
